import { access } from '@driftt/traffic-control'
import React from 'react'

import LeadQualification from 'components/AIConfiguration/LeadQualification'
import usePageTitle from 'hooks/usePageTitle'

const AIConfiguration = () => {
  const isAdmin = access.isAdmin()

  usePageTitle('Drift | AI Configuration')

  return isAdmin ? <LeadQualification /> : null
}

export default AIConfiguration
